// TODO: bundle check variable google

export class PropertyHandler {
    constructor() {
        if ($('.map_data').length) {
            let map_data = document.querySelectorAll('.map_data .property');
            this.setMapData(map_data);
            document.querySelector('.map_data').remove();
        }
        if ($('#mortgage').length) {
            $('body').on('click', '.mortgage-trigger', function (e) {
                $('#mortgage').toggleClass('active');
            });
            $('body').on('click', '.mortgage-reset', function (e) {
                // $('.mortgage-result').text($('.mortgage-initial_result').text())
                $('#mortgage form')[0].reset();
            });
            $('body').on('click', '.mortgage-calc', function (e) {
                $('#mortgage form').first().trigger('submit');
            });
            $('body').on('submit', '#mortgage form', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                let $this = $(e.target);
                let payment = this.calcMortgage($this);
                let formatted_payment = payment + '$ / ' + $this.find('[name="payment_frequency"] option:selected').text();
                $('.mortgage-result').text(formatted_payment);
                return false;
            }.bind(this));
        }
        $('body').on('click', '.property_display', function (e) {
            let display = ($(this).attr('data-display') ?? 'grid');
            $('.properties--grid').toggleClass('display', (display === 'grid'));
            $('.properties--map').toggleClass('display', (display === 'map'));
        });
    }

    setMapData(map_data) {
        let map_element = $('.properties_map').first();
        if (map_element.length) {
            let info_windows_html = map_data;
            if (typeof map_data == 'string') {
                info_windows_html = $.parseHTML(map_data);
            }
            let bounds = new google.maps.LatLngBounds();
            let zoom = 15;
            let center;
            let map = new google.maps.Map(map_element[0], {
                zoom: zoom,
                streetViewControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            if (info_windows_html.length) {
                let fit_bounds = false;
                info_windows_html.forEach((element, index) => {
                    if ($(element).hasClass('property')) {
                        fit_bounds = true;
                        let info_window = new google.maps.InfoWindow({
                            content: element.outerHTML
                        });
                        center = new google.maps.LatLng(element.getAttribute('data-latitude'), element.getAttribute('data-longitude'));
                        let marker = new google.maps.Marker({
                            position: center,
                            map: map,
                            icon: 'public/rubberduck/images/SVG/map-marker.svg'
                        });

                        bounds.extend(marker.position);

                        marker.addListener('click', function () {
                            // Open new info window
                            $('.gm-style-iw-a').fadeOut(200, function () {
                                $(this).remove();
                            })
                            info_window.open({
                                anchor: marker,
                                map,
                                shouldFocus: false,
                            });
                        });
                    }
                });
                if (center) map.setCenter(center);
                if (fit_bounds && info_windows_html.length > 1) map.fitBounds(bounds);
            }
        }
    }
    
    calcMortgage(form) {
        let amount = parseFloat(form.find('[name="mortgage_amount"]').val());
        let amortization = parseFloat(form.find('[name="amortization"]').val());
        let interest_rate = parseFloat(form.find('[name="interest_rate"]').val());
        let frequency_value = form.find('[name="payment_frequency"]').val();
        let frequency = parseInt(frequency_value);
        if (isNaN(amount) === true) amount = 0;
        if (isNaN(amortization) === true) amortization = 0;
        if (isNaN(interest_rate) === true) interest_rate = 0;
        if (isNaN(frequency) === true) frequency = 0;
    
        let total_period = amortization * frequency;
        interest_rate = interest_rate / 100;
        
        let interest = Math.pow((1 + interest_rate / 2), (2 / frequency)) - 1;
        let base_interest = Math.pow((1 + interest_rate / 2), (2 / 12)) - 1;
        let base_payment = 0;
        if (interest == 0) {
            base_payment  = amount / (amortization * 12) ;
        } else {
            base_payment  = (amount * base_interest) / ( 1 - ( 1/ Math.pow((1+base_interest),(amortization*12))));
        }
    
        let payment = base_payment;
    
        if ((frequency_value == '52a' ||frequency_value == '26a') && interest != 0 ) {
            payment = base_payment / (frequency / 13);
        }
    
        if ((frequency_value == '52' || frequency_value == '26'|| frequency_value == '2'|| frequency_value == '1' ) && interest != 0 ) {
            payment = (amount * interest) / (1 - (1/ Math.pow((1 + interest), total_period)));
        }
        
    
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    
        return isNaN(payment) ? formatter.format(0).substring(1) : formatter.format(payment.toFixed(2)).substring(1);
    }
}